import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import Gauge from '../../library/gauge/gauge';

import styles from './rating-gauge.scss';

function RatingGauge(props) {
  const { className, label, rating, title } = props;
  return (
    <div className={cn(styles['container'], `rating-gauge ${className || ''}`)}>
      {title && (
        <span className={cn(styles['title'], 'rating-gauge__title')}>
          {title}
        </span>
      )}
      <Gauge className="rating-gauge__gauge" value={rating} />
      <span className={styles['label']}>{label}</span>
    </div>
  );
}

RatingGauge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  rating: PropTypes.number,
  title: PropTypes.string
};

export default RatingGauge;
